import React, { useState } from 'react';
import { FloatingPortal, autoUpdate, flip, offset, shift, useDismiss, useFloating, useFocus, useHover, useInteractions, useRole, } from '@floating-ui/react';
import * as S from './AnalyticsTooltip.styled';
export const AnalyticsTooltip = ({ content, children, placement = 'top', offset: offsetValue = 8, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        placement,
        middleware: [
            offset(offsetValue),
            flip({
                fallbackPlacements: ['top', 'bottom', 'left', 'right'],
            }),
            shift({ padding: 8 }),
        ],
        whileElementsMounted: autoUpdate,
    });
    const hover = useHover(context);
    const focus = useFocus(context);
    const dismiss = useDismiss(context);
    const role = useRole(context, { role: 'tooltip' });
    const { getReferenceProps, getFloatingProps } = useInteractions([hover, focus, dismiss, role]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: refs.setReference, ...getReferenceProps() }, children),
        isOpen && (React.createElement(FloatingPortal, null,
            React.createElement("div", { ref: refs.setFloating, style: floatingStyles, ...getFloatingProps() },
                React.createElement(S.TooltipContent, null, content))))));
};
